import Brandmark from "./Brandmark";
import { config } from "../../config";
import "./Nav.css";

interface NavProps {
  onWaitlistClick: () => void;
}

/**
 * Top nav for the marketing site.
 *
 * Lockup hierarchy per ORBITCELL_CONTROL_PLANE_DESIGN_GUIDELINES.md:
 *   - icon  28-32 px
 *   - wordmark  16-20 px, display face, 700-800
 *   - parent line "a JoatLabs.dev platform" (or whatever VITE_PARENT_NAME is)
 *     at 9-11 px, muted, regular/medium weight, with the parent name
 *     linking to its homepage.
 *
 * Sign in enters the product login flow. Join the waitlist remains the
 * pre-launch marketing intent capture.
 */
export default function Nav({ onWaitlistClick }: NavProps) {
  const loginHref = `${config.appBaseUrl || ""}/login`;

  return (
    <nav className="oc-nav" aria-label="Primary">
      <div className="oc-nav-logo">
        <a href="/" className="oc-nav-home" aria-label={`${config.brandName} home`}>
          <Brandmark size={30} ariaLabel={config.brandName} />
        </a>
        <span className="oc-nav-lockup">
          <a href="/" className="oc-nav-wordmark">{config.brandName}</a>
          {config.parentName && (
            <span className="oc-nav-parent">
              a{" "}
              {config.parentUrl ? (
                <a
                  href={config.parentUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="oc-nav-parent-link"
                >
                  {config.parentName}
                </a>
              ) : (
                config.parentName
              )}{" "}
              platform
            </span>
          )}
        </span>
      </div>

      <div className="oc-nav-links">
        <a href="/#platform">Platform</a>
        <a href="/#workflow">Workflow</a>
        <a href="/#readiness">Readiness</a>
      </div>

      <div className="oc-nav-actions">
        <a className="btn btn-ghost" href={loginHref}>
          Sign in
        </a>
        <button type="button" className="btn btn-primary" onClick={onWaitlistClick}>
          Join the waitlist
        </button>
      </div>
    </nav>
  );
}
